export const jobCodes = {
    0: {
        // MT
        id: 0,
        // jobCode: 'US-KLX-00273 02/24',
        jobCode: 'US-KLX-00626 07/26',
    },
    1: {
        // RCC
        id: 1,
        jobCode: 'US-KLR-00584 09/24',
    },
    2: {
        // ENDO
        id: 2,
        jobCode: 'US-KLE-01639 05/26',
    },
};
